import { ChevronRight, CircleAlert } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Bandeau « à faire maintenant » sur la vue d’ensemble — pousse vers les onglets à fort enjeu.
 * @param {Array<{ tab: string; label: string; count?: number }>} items
 * @param {(tab: string) => void} onGoTab
 */
export default function DashboardPriorityBanner({ items = [], onGoTab, className }) {
  if (!items.length) return null;

  return (
    <section
      className={cn(
        "mb-6 rounded-2xl border border-amber-200/90 bg-gradient-to-br from-amber-50/95 to-white p-4 shadow-sm sm:p-5",
        className
      )}
      data-testid="dash-priority-banner"
      aria-label="Actions prioritaires"
    >
      <div className="mb-3 flex items-center gap-2">
        <CircleAlert className="h-5 w-5 shrink-0 text-amber-600" aria-hidden />
        <h3 className="font-display text-sm font-bold uppercase tracking-wide text-amber-900">
          À traiter en priorité
        </h3>
      </div>
      <ul className="space-y-2">
        {items.map((item) => (
          <li key={`${item.tab}-${item.label}`}>
            <button
              type="button"
              onClick={() => onGoTab(item.tab)}
              className="group flex w-full items-center gap-3 rounded-xl border border-amber-100/80 bg-white/80 px-4 py-3 text-left transition hover:border-amber-300 hover:bg-white hover:shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/50"
              data-testid={`dash-priority-${item.tab}`}
            >
              <span className="min-w-0 flex-1 text-sm font-medium text-slate-800">{item.label}</span>
              {item.count != null && item.count > 0 ? (
                <span className="shrink-0 rounded-full bg-amber-500 px-2 py-0.5 text-xs font-bold tabular-nums text-white">
                  {item.count}
                </span>
              ) : null}
              <ChevronRight
                className="h-4 w-4 shrink-0 text-slate-400 transition group-hover:translate-x-0.5 group-hover:text-amber-700"
                aria-hidden
              />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
